import { bemBuilder } from "@chatfood/core-utils";

const className = "loyalty-program-guest";

export const css = bemBuilder(className);
export const cssq = bemBuilder(className, true);
